import React from "react"
import style from "./Input.css"

export const InputText = (props) => {
    return <input {...props} type="text" className={style.input}/>
}

export const InputTextCenter = (props) => {
    return <input {...props} type="text" className={style.input} style={{textAlign: "center"}}/>
}

export const InputSize = (props) => {
    return <input {...props} type="number" className={style.input}/>
}

export const InputEmail = (props) => {
    return <input type="email" className={style.input} {...props}/>
}

export const InputSelect = ({value, options, onChange, local}) => {
    return <select onChange={onChange} defaultValue={value} className={style.select}>
        {options.map(option => {
            return <option key={option.code} value={option.code}>
                {local.getLabel(option.name)}
            </option>
        })}
    </select>
}

export const InputRadio = ({children, onClick, isActive}) => {
    return <div className={style.radio} onClick={onClick}>
        <div>{isActive && <div/>}</div>
        <div>{children}</div>
    </div>
}